export default {"src":"/_next/static/media/coins-animated.1181937c.svg","height":862,"width":806,"blurWidth":0,"blurHeight":0};